import * as React from "react";
const SvgFiRrFaceDisappointed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-disappointed_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m3.598-4.802a1 1 0 0 1-1.196 1.603c-.007-.005-1.113-.802-2.402-.802s-2.396.797-2.406.805a1 1 0 0 1-1.396-.213 1 1 0 0 1 .205-1.394c.066-.049 1.632-1.198 3.598-1.198s3.531 1.149 3.598 1.198zm-5.259-4.2-4 1.442a.998.998 0 1 1-.677-1.88l4-1.442a.997.997 0 0 1 1.279.602.997.997 0 0 1-.602 1.278m8.602.841a1 1 0 0 1-1.279.601l-4-1.442a1 1 0 0 1 .677-1.881l4 1.442a1 1 0 0 1 .602 1.28"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-disappointed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceDisappointed;
